/**
 * Refactored
 * @see static/scripts/legacy/mobile-navi-hide-on-scroll.js for legacy code
 */
import n, { N } from "@/lib/n";
import type NItem from "@/lib/NItem";

export default class HideOnScroll
{
    #menuItem: NItem|null;
    #dataSearch: N|null;
    #scrollTimeout: number|undefined;
    #scrollTimeoutTime: number = 200;
    #lastScrollTop = 0;

    constructor()
    {
        this.#menuItem = n('.sitesmartMobileNavi__item--menu').get();
        this.#dataSearch = n('.sitesmart-ecommerce-data-search.active');
        this.initEvents();
    }

    initEvents(): void
    {
        window.addEventListener('scroll', () => {
            const scrollTop = window.scrollY;

            if (scrollTop > this.#lastScrollTop) {
                if (!this.#menuItem?.hasClass('sitesmartMobileNavi__item--active')
                    && this.#dataSearch?.length === 0) {
                    n('nav.sitesmartMobileNavi--hideOnScroll').each((nav: NItem) => {
                        if (!nav.hasClass('sitesmartMobileNavi--hideOnScroll--hidden')) {
                            nav.addClass('sitesmartMobileNavi--hideOnScroll--hidden');
                        }
                    });
                }
            } else {
                n('nav.sitesmartMobileNavi--hideOnScroll').each((nav: NItem) => {
                    nav.removeClass('sitesmartMobileNavi--hideOnScroll--hidden');
                });
            }

            clearTimeout(this.#scrollTimeout);
            this.#scrollTimeout = setTimeout(() => {
                this.#lastScrollTop = scrollTop;
            }, this.#scrollTimeoutTime);
        });
    }
}
